import { useState, useEffect } from "react";
import Button from "../../../../Custom/Button/Button";
import styles from "../styles";
import CustomSelect from "../../globalno-dodavanje/CustomSelect";
import CustomSelectSimple from "../CustomSelectSimple";
import CustomCalendarInput from "../CustomCalendarInput";
import axios from "axios";
import { useGlobalContext } from "../../../../../Context/Context";

const tipPregledaAll = ["PRETHODNI", "PERIODICNI", "CILJANI"];
const idBrojAll = ["CAS BROJ", "ES BROJ", "INDEKS"];
const klaseAll = ["KLASA 1", "KLASA 2", "KLASA 3", "KLASA 4"];
const promenaAll = ["IMA", "NEMA"];
const izlozenostAll = ["DNEVNO", "NEDELJNO", "MESECNO"];

const nowDate = new Date()
  .toLocaleDateString("sr-RS", { day: "2-digit", month: "2-digit", year: "numeric" })
  .replaceAll("/", ".")
  .slice(0, -1);

const emptyObrazac = {
  radnoMesto: { id: -1, name: "" },
  zaposlen: { id: -1, name: "" },
  naziv: "",
  id_broj: "",
  broj: "",
  klasa: "",
  tipPregleda: "PERIODICNI",
  datum: nowDate,
  datumSledeci: nowDate,
  brojIzvestaja: "",
  promena: "",
  izlozenost: "",
  napomena: "",
};

const cs = {
  border: "1px solid black",
  padding: "4px",
  textAlign: "center",
  verticalAlign: "middle",
  fontSize: "12px",
};

const tipLabel = { PRETHODNI: "Претходни", PERIODICNI: "Периодични", CILJANI: "Циљани" };

function Dodavanje({ handleZatvori, sacuvajAzurirano, lookups }) {
  const [obrazac, setObrazac] = useState(emptyObrazac);
  const { baseUrl, selectedMainEntity } = useGlobalContext();

  const filteredZaposleni = obrazac.radnoMesto.id === -1
    ? (lookups.zaposleni || [])
    : (lookups.zaposleni || []).filter(z => String(z.workplace_id) === String(obrazac.radnoMesto.id));

  const filteredRadnaMesta = obrazac.zaposlen.id === -1
    ? (lookups.radna_mesta || [])
    : (lookups.radna_mesta || []).filter(rm => {
        const z = (lookups.zaposleni || []).find(z => String(z.id) === String(obrazac.zaposlen.id));
        return z ? String(rm.id) === String(z.workplace_id) : true;
      });

  const handleChange = (val, field) => setObrazac(prev => ({ ...prev, [field]: val }));

  const handleRadnoMestoChange = (rm) => {
    setObrazac(prev => {
      const zaposlenStillValid = prev.zaposlen.id === -1 ||
        (lookups.zaposleni || []).some(z => String(z.id) === String(prev.zaposlen.id) && String(z.workplace_id) === String(rm.id));
      return { ...prev, radnoMesto: rm, zaposlen: zaposlenStillValid ? prev.zaposlen : { id: -1, name: "" } };
    });
  };

  const handleZaposlenChange = (z) => {
    const zData = (lookups.zaposleni || []).find(e => String(e.id) === String(z.id));
    if (zData?.workplace_id) {
      const rm = (lookups.radna_mesta || []).find(r => String(r.id) === String(zData.workplace_id));
      if (rm) { setObrazac(prev => ({ ...prev, zaposlen: z, radnoMesto: { id: rm.id, name: rm.name } })); return; }
    }
    setObrazac(prev => ({ ...prev, zaposlen: z }));
  };

  const formatDateForApi = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.replace(/\.$/, "").split(".");
    if (parts.length < 3) return null;
    const y = parts[2].length === 2 ? (parseInt(parts[2]) < 50 ? "20" : "19") + parts[2] : parts[2];
    return `${y}-${parts[1]}-${parts[0]}`;
  };

  const handleSacuvaj = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija5/create.php`, {
        company_id: selectedMainEntity.company_id,
        workplace_id: obrazac.radnoMesto.id,
        employee_id: obrazac.zaposlen.id,
        naziv: obrazac.naziv,
        id_broj: obrazac.id_broj,
        broj: obrazac.broj,
        klasa: obrazac.klasa,
        tip_pregleda: obrazac.tipPregleda,
        datum_pregleda: formatDateForApi(obrazac.datum),
        datum_sledeci: formatDateForApi(obrazac.datumSledeci),
        broj_izvestaja: obrazac.brojIzvestaja,
        promena: obrazac.promena,
        izlozenost: obrazac.izlozenost,
        napomena: obrazac.napomena,
      });
      if (data.status === 200) { sacuvajAzurirano && sacuvajAzurirano(); handleZatvori(); }
    } catch (e) { console.error(e); }
  };

  const isDisabled = obrazac.radnoMesto.id === -1 || obrazac.zaposlen.id === -1 ||
    !obrazac.naziv || !obrazac.id_broj || !obrazac.klasa || !obrazac.tipPregleda;

  return (
    <div>

      {/* LIVE PREVIEW OBRASCA */}
      <div style={{ overflowY: "auto", maxHeight: "250px", background: "white", padding: "20px", border: "1.5px solid #9f9f9f", marginBottom: "15px" }}>
        <div style={{ fontWeight: "bold", textAlign: "center", marginBottom: "15px" }}>
          <div>Образац 5</div>
          <div>ЕВИДЕНЦИЈА О ЗАПОСЛЕНИМА КОЈИ СУ ИЗЛОЖЕНИ КАРЦИНОГЕНИМА ИЛИ МУТАГЕНИМА, ХЕМИЈСКИМ МАТЕРИЈАМА И АЗБЕСТУ, КАО И О ЗДРАВСТВЕНОМ СТАЊУ И ИЗЛОЖЕНОСТИ</div>
        </div>

        <div style={{ display: "flex", marginBottom: "15px" }}>
          <div style={{ width: "33%", textAlign: "center" }}>
            <hr style={{ width: "80%", margin: "0 auto 5px" }} />
            Пословно ime послодавца
          </div>
          <div style={{ width: "33%", textAlign: "center" }}>
            <hr style={{ width: "80%", margin: "0 auto 5px" }} />
            Адреса седишта послодавца
          </div>
          <div style={{ width: "33%", textAlign: "center" }}>
            <hr style={{ width: "80%", margin: "0 auto 5px" }} />
            ПИБ послодавца
          </div>
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th style={cs}>Редни број</th>
              <th style={cs}>Назив карциногена или мутагена, хемијске материје и азбеста</th>
              <th style={cs}>CAS број</th>
              <th style={cs}>ES број</th>
              <th style={cs}>Класа опасности</th>
              <th style={cs}>Ime и презиме запосленог</th>
              <th style={cs}>Назив радног места</th>
              <th style={cs}>Тип прегледа</th>
              <th style={cs}>Датум извршеног прегледа</th>
              <th style={cs}>Датум следећег прегледа</th>
              <th style={cs}>Број лекарског извештаја</th>
              <th style={cs}>Промена здравственог стања</th>
              <th style={cs}>Изложеност</th>
              <th style={{ ...cs, width: "120px" }}>Напомена</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={cs}>1.</td>
              <td style={cs}>{obrazac.naziv}</td>
              <td style={cs}>{obrazac.id_broj === "CAS BROJ" ? obrazac.broj : ""}</td>
              <td style={cs}>{obrazac.id_broj === "ES BROJ" ? obrazac.broj : ""}</td>
              <td style={cs}>{obrazac.klasa}</td>
              <td style={cs}>{obrazac.zaposlen.name}</td>
              <td style={cs}>{obrazac.radnoMesto.name}</td>
              <td style={cs}>{tipLabel[obrazac.tipPregleda] || obrazac.tipPregleda}</td>
              <td style={{ ...cs, fontWeight: "bold" }}>{obrazac.datum}</td>
              <td style={{ ...cs, fontWeight: "bold" }}>{obrazac.datumSledeci}</td>
              <td style={cs}>{obrazac.brojIzvestaja}</td>
              <td style={cs}>{obrazac.promena}</td>
              <td style={cs}>{obrazac.izlozenost}</td>
              <td style={{ ...cs, maxWidth: "120px", wordBreak: "break-word" }}>{obrazac.napomena}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* FORMA */}
      <div>
        {/* Red 1 */}
        <div style={{ display: "flex", gap: "10px", width: "100%", justifyContent: "space-between" }}>
          <div style={{ width: "15vw" }}>
            <CustomSelect label="RADNO MESTO" allValues={filteredRadnaMesta}
              selectedValue={obrazac.radnoMesto} onSelectChange={handleRadnoMestoChange} />
          </div>
          <div style={{ width: "15vw" }}>
            <CustomSelect label="IME I PREZIME" allValues={filteredZaposleni}
              selectedValue={obrazac.zaposlen} onSelectChange={handleZaposlenChange} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={styles.natpis}>NAZIV KARCINOGENA</div>
            <input value={obrazac.naziv} onChange={e => handleChange(e.target.value, "naziv")}
              style={{ fontSize: "14px", height: "40px", padding: "10px", width: "100%" }} />
          </div>
          <div style={{ width: "10vw" }}>
            <CustomSelectSimple label="ID BROJ" allValues={idBrojAll}
              selectedValue={obrazac.id_broj} onSelectChange={v => handleChange(v, "id_broj")} isUp />
          </div>
          <div style={{ width: "8vw" }}>
            <div style={styles.natpis}>BROJ</div>
            <input value={obrazac.broj} onChange={e => handleChange(e.target.value, "broj")}
              style={{ fontSize: "14px", height: "40px", padding: "10px", width: "100%" }} />
          </div>
          <div style={{ width: "10vw" }}>
            <CustomSelectSimple label="KLASA" allValues={klaseAll}
              selectedValue={obrazac.klasa} onSelectChange={v => handleChange(v, "klasa")} isUp />
          </div>
        </div>

        {/* Red 2 */}
        <div style={{ display: "flex", gap: "10px", width: "100%", justifyContent: "space-between", marginTop: "10px" }}>
          <div style={{ width: "10vw" }}>
            <CustomSelectSimple label="TIP PREGLEDA" allValues={tipPregledaAll}
              selectedValue={obrazac.tipPregleda} onSelectChange={v => handleChange(v, "tipPregleda")} isUp />
          </div>
          <div>
            <CustomCalendarInput label="IZVRŠEN" value={obrazac.datum} onChange={v => handleChange(v, "datum")} />
          </div>
          <div>
            <CustomCalendarInput label="SLEDEĆI" value={obrazac.datumSledeci} onChange={v => handleChange(v, "datumSledeci")} />
          </div>
          <div style={{ width: "10vw" }}>
            <div style={styles.natpis}>BROJ IZVEŠTAJA</div>
            <input value={obrazac.brojIzvestaja} onChange={e => handleChange(e.target.value, "brojIzvestaja")}
              style={{ fontSize: "14px", height: "40px", padding: "10px", width: "100%" }} />
          </div>
          <div style={{ width: "8vw" }}>
            <CustomSelectSimple label="PROMENA" allValues={promenaAll}
              selectedValue={obrazac.promena} onSelectChange={v => handleChange(v, "promena")} isUp />
          </div>
          <div style={{ width: "10vw" }}>
            <CustomSelectSimple label="IZLOŽENOST" allValues={izlozenostAll}
              selectedValue={obrazac.izlozenost} onSelectChange={v => handleChange(v, "izlozenost")} isUp />
          </div>
          <div style={{ flex: 1 }}>
            <div style={styles.natpis}>NAPOMENA</div>
            <input value={obrazac.napomena} onChange={e => handleChange(e.target.value, "napomena")}
              style={{ fontSize: "14px", height: "40px", padding: "10px", width: "100%" }} />
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
          <div onClick={handleZatvori}>
            <Button activation={true} style={styles.button}>ODUSTANI</Button>
          </div>
          <div onClick={isDisabled ? undefined : handleSacuvaj} style={{ opacity: isDisabled ? 0.5 : 1 }}>
            <Button isDisabled={isDisabled} activation={true} style={styles.button}>SACUVAJ</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dodavanje;